// import { GroupCellRenderer } from "ag-grid-community";

/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: GCI 2020
  Author: Dtsmart
  Author URL: http://dtsmart.vn
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "home",
    icon: "BarChartIcon",
    type: "admin",
    admin_type: "gocheckin,order,appointment"
  },
  // {
  //   url: "/checkin",
  //   name: "Check In",
  //   slug: "checkin",
  //   icon: "LogInIcon",
  // },
  {
    url: "/checkout",
    name: "Checkout",
    slug: "checkout",
    icon: "CheckSquareIcon",
    type: "checkout"
  },
  {
    url: "/checkout/history",
    name: "History",
    slug: "history",
    icon: "ClockIcon",
    type: "checkout"
  },
  {
    url: "/appointment",
    name: "Booking",
    slug: "appointment",
    icon: "CalendarIcon",
    type: "appointment"
  },
  // {
  //   url: "/article",
  //   name: "Article",
  //   slug: "article",
  //   icon: "LayersIcon",
  //   type: "article"
  // },
  {
    url: null,
    name: "Setting",
    icon: "SettingsIcon",
    submenu:[
      {
        url: "/block-time",
        name: "Block Time Setting",
        slug: "block-time",
        type: 'appointment'
      },
      {
        url: "/go-booking-settings",
        name: "Go Booking Settings",
        slug: "go-booking-settings",
        type: 'appointment'
      }
    ],
    type: "appointment",
  },
  // {
  //   url: "/booking-staff",
  //   name: "Booking Staff Setting",
  //   slug: "booking-staff",
  //   icon: "ClockIcon",
  //   type: "appointment"
  // },
  {
    url: null,
    name: "Promo & Reminder",
    icon: "ClockIcon",
    i18n: "PromoAndReminder",
    submenu:[
      {
        url: "/promotion",
        name: "Promotion",
        slug: "promotion",
        i18n: "Promotion",
      },
      {
        url: "/reminder",
        name: "Reminder",
        slug: "reminder",
        i18n: "Reminder",
      },
      {
        url: "/birthday",
        name: "Birthday",
        slug: "birthday",
        i18n: "Birthday"
      },
      {
        url: "/new-client",
        name: "New Client",
        slug: "new-client",
        i18n: "NewClient"
      },
    ],
    type: "admin",
    admin_type: "gocheckin"
  },
  {
    url: null,
    name: "Staff & Service",
    icon: "UserIcon",
    i18n: "StaffAndService",
    submenu:[
      {
        url: "/staff",
        name: "Staff",
        slug: "staff",
        icon: "UserIcon",
      },
      {
        url: "/service",
        name: "Services",
        slug: "service",
        icon: "MenuIcon"
      },
    ],
    type: "admin",
    admin_type: "gocheckin,appointment"
  },
  // {
  //   url: "/inventory",
  //   name: "Inventory",
  //   slug: "inventory",
  //   icon: "BoxIcon",
  // },
  {
    url: null,
    name: "Member & Group",
    icon: "UsersIcon",
    i18n: "MemberAndGroup",
    submenu:[
      {
        url: "/customer",
        name: "Customer",
        slug: "customer",
        icon: "UserIcon",
      },
      {
        url: "/group",
        name: "Group",
        slug: "group",
        icon: "UsersIcon",
      }
    ],
    type: "admin",
    admin_type: "gocheckin"
  },
  {
    url: "/reward",
    name: "Reward",
    slug: "reward",
    icon: "DollarSignIcon",
    type: "admin",
    admin_type: "gocheckin"
  },
  {
    name: "Review",
    slug: "review",
    icon: "StarIcon",
    submenu: [
      {
        url: "/review_list",
        name: "Review list",
        slug: "review_list",
      },
      {
        url: "/review_setting",
        name: "Review setting",
        slug: "review_setting",
      },
      // {
      //   url: "/staff_rating",
      //   name: "Staff rating",
      //   slug: "staff_rating",
      //   type: 'admin',
      //   admin_type: 'gopos'
      // }
    ],
    type: "admin",
    admin_type: "gocheckin, gopos"
  },
  {
    name: "Order settings",
    slug: "order-settings",
    icon: "ShoppingCartIcon",
    submenu: [
      {
        url: "/online-order/category",
        name: "Category",
        slug: "category",
        type: "admin",
        admin_type: "order"
      },
      {
        url: "/online-order/item",
        name: "Item",
        slug: "item",
        type: "admin",
        admin_type: "order"
      },
      {
        url: "/online-order/modifier",
        name: "Modifier",
        slug: "modifier",
        type: "admin",
        admin_type: "order"
      },
    ],
    type: "admin",
    admin_type: "order"
  },
  {
    url: "/online-order/order",
    name: "Order",
    slug: "reward",
    icon: "ShoppingCartIcon",
    type: "order"
  },
  {
    url: "/online-order/invoice",
    name: "Invoice",
    slug: "reward",
    icon: "ClipboardIcon",
    type: "order"
  },
  // {
  //   url: "/go-pos/dashboard",
  //   name: "Dashboard",
  //   slug: "go-pos-dashboard",
  //   icon: "BarChartIcon",
  //   type: "gopos"
  // },
  {
    name: "Report",
    slug: "go-pos-report",
    icon: "BarChart2Icon",
    image_icon: "/gopos-report-icon.png",
    submenu: [
      {
        url: "/go-pos/income",
        name: "Income",
        slug: "go-pos-income",
        // icon: "BarChartIcon",
        type: "gopos"
      },
      {
        url: "/go-pos/dashboard",
        name: "Orders",
        slug: "go-pos-dashboard",
        // icon: "BarChartIcon",
        type: "gopos"
      },
    ],
    type: "gopos"
  },
  {
    // url: "/go-pos/payroll",
    name: "Payroll",
    slug: "payroll",
    icon: "DollarSignIcon",
    submenu: [
      {
        url: "/go-pos/payroll",
        name: "Paysheet",
        slug: "payroll",
        icon: "DollarSignIcon",
        type: "gopos"
      },
      {
        url: "/go-pos/staff-daily-income",
        name: "Staff Daily Income",
        slug: "staff-daily-income",
        icon: "DollarSignIcon",
        type: "gopos"
      },
      {
        url: "/staff_rating",
        name: "Staff Rating",
        slug: "staff_rating",
        type: 'admin',
        admin_type: 'gopos'
      }
    ],
    type: "gopos"
  },
  {
    url: "/go-pos/batch-history",
    name: "Batch History",
    slug: "batch-history",
    icon: "ClipboardIcon",
    type: "gopos"
  },
  {
    url: "/go-pos/timekeeping",
    name: "Time Keeping",
    slug: "timekeeping",
    icon: "CalendarIcon",
    type: "gopos"
  },
  // {
  //   url: "/go-pos/reseller",
  //   name: "Reseller",
  //   slug: "reseller",
  //   icon: "UsersIcon",
  //   type: "gopos"
  // },
  {
    url: "/go-pos/ticket-template",
    name: "Ticket Template",
    slug: "ticket-template",
    icon: "FileIcon",
    type: "gopos"
  },
  {
    url: "/go-pos/giftcard",
    name: "Gift Card",
    slug: "giftcard",
    icon: "GiftIcon",
    type: "gopos"
  },
]
